export { default as withSuspense } from './withSuspense';
